// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TiFku","dividerHorizontal":"Header_dividerHorizontal__LGarw"};